<video
  #videoPlayer
  controls
  controlsList="nodownload"
  id="content-video-{{ videoAssetId }}"
  (error)="onErrorFuncAllowed && fetchVideoUrl(true)"
  oncontextmenu="return false;"
  [className]="videoClass"
  (timeupdate)="isTimeUpdate && onTimeUpdateFunc($event)"
  (play)="onMediaPlay()"
  (pause)="onMediaPause()"
  [attr.preload]="preloadMode"
  [attr.poster]="posterUrl || null"
  [src]="primaryUrl"
  type="video/mp4"
  >
  Your browser doesn't support video playback.
</video>
@if (isTimeUpdate) {
  <div class="clearfix"></div>
  <div class="left">
    <!-- href test -->
    <a
      class="download-btn"
      (click)="
        downloadAssetFunc('/api/Assets/ChallengeDownload/' + videoAssetId)
      "
      >
      Download
    </a>
  </div>
  <div class="right cursor-pointer" (click)="addVideoComment()">
    <i class="material-icons icon-orange">chat</i>
  </div>
}
